import {
  APPLICATION_SETTINGS_PAGE_TITLE,
  CRON_JOB_SEARCH_PAGE_TITLE,
  PRICING_PAGE_TITLE,
  SETTING_APPLICATION_DASHBOARD_PAGE_TITLE,
  TENANT_SEARCH_PAGE_TITLE,
  TRANSLATION_SEARCH_PAGE_TITLE,
} from "ui/components/PageTitle/consts";
import { SidebarItem } from "./components/SidebarItem/types";

/*------------------------------------------------------------------
  NAVIGACIJA ADMINISTRATORSKE APLIKACIJE

  Namjerno se ne kopira iz korisničke — ovdje nema flote, prodaje ni
  financija, nego samo ono što je naše.

  Nijedna stavka nema podstavke: svaka vodi na svoj ekran, a dalje se
  ide odande. Cjenik tako otvara pretragu verzija.
-------------------------------------------------------------------*/

/** Početni ekran administracije. */
export const SIDEBAR_ITEM_DASHBOARD: SidebarItem = {
  text: SETTING_APPLICATION_DASHBOARD_PAGE_TITLE.text,
  icon: SETTING_APPLICATION_DASHBOARD_PAGE_TITLE.icon,
  route: SETTING_APPLICATION_DASHBOARD_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_TENANTS: SidebarItem = {
  text: TENANT_SEARCH_PAGE_TITLE.text,
  icon: TENANT_SEARCH_PAGE_TITLE.icon,
  route: TENANT_SEARCH_PAGE_TITLE.route,
};

export const SIDEBAR_ITEM_TRANSLATIONS: SidebarItem = {
  text: TRANSLATION_SEARCH_PAGE_TITLE.text,
  icon: TRANSLATION_SEARCH_PAGE_TITLE.icon,
  route: TRANSLATION_SEARCH_PAGE_TITLE.route,
};

/**
 * Jedna stavka bez podstavki: vodi na pretragu cjenika, a odatle se ide na pojedinu verziju,
 * sheme i odstupanja. Vodoravni izbornik na tim ekranima ionako ponavlja iste veze.
 */
export const SIDEBAR_ITEM_PRICING: SidebarItem = {
  text: "Cjenik",
  icon: PRICING_PAGE_TITLE.icon,
  route: PRICING_PAGE_TITLE.route,
};

/**
 * Obrade: pregled vrsta obrada, pojedinih obrada i njihovih logova te reset statusa kad obrada
 * zapne. Vodi na popis vrsta obrada; obrade i log su ekrani ispod njega.
 */
export const SIDEBAR_ITEM_CRON_JOBS: SidebarItem = {
  text: CRON_JOB_SEARCH_PAGE_TITLE.text,
  icon: CRON_JOB_SEARCH_PAGE_TITLE.icon,
  route: CRON_JOB_SEARCH_PAGE_TITLE.route,
};

/** Zupčanik vodi ravno na postavke aplikacije — nema podstavki ispod sebe. */
export const SIDEBAR_ITEM_SETTINGS: SidebarItem = {
  text: APPLICATION_SETTINGS_PAGE_TITLE.text,
  icon: APPLICATION_SETTINGS_PAGE_TITLE.icon,
  route: APPLICATION_SETTINGS_PAGE_TITLE.route,
};

/*------------------------------------------------------------------
  RESULT
-------------------------------------------------------------------*/
export const SIDEBAR_ITEMS: SidebarItem[] = [
  SIDEBAR_ITEM_DASHBOARD,
  SIDEBAR_ITEM_TENANTS,
  SIDEBAR_ITEM_TRANSLATIONS,
  SIDEBAR_ITEM_PRICING,
  SIDEBAR_ITEM_CRON_JOBS,
  SIDEBAR_ITEM_SETTINGS,
];
